import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/app/Header";
import Footer from "@/components/app/Footer";
import { Toaster } from "@/components/ui/sonner";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}
